import React from 'react'
import styled from 'styled-components'
import logo from '../assets/footer-logo.svg'
import { contentWidth } from './common/common'

import twitterIcon from '../assets/twitter-icon.svg'
import instagramIcon from '../assets/instagram-icon.svg'
import youtubeIcon from '../assets/youtube-icon.svg'

const Container = styled.footer`
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding: 64px 0;
  margin-top: 80px;

  @media only screen and (max-width: 900px) {
    padding: 40px 0 48px;
    margin-top: 48px;
  }
`

const ContentWrapper = styled.div`
  ${contentWidth}
  display: flex;
  justify-content: space-between;
  gap: 32px;

  @media only screen and (max-width: 1100px) {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px 24px;
  }

  @media only screen and (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

// Brand sits on its own row once the footer collapses to a grid
const BrandCol = styled(Col)`
  @media only screen and (max-width: 1100px) {
    grid-column: 1 / -1;
  }
`

// Full width on phones so the email address never gets squeezed
const ContactCol = styled(Col)`
  @media only screen and (max-width: 900px) {
    grid-column: 1 / -1;
  }
`

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`

const Logo = styled.img`
  margin-right: 10px;
`

const Heading = styled.span`
  font-weight: bold;
  font-size: 38px;

  @media only screen and (max-width: 900px) {
    font-size: 30px;
  }
`

const Title = styled.span`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 5px;
`

const SectionTitle = styled.span`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
`

const Text = styled.div`
  color: #828493;
  max-width: 300px;
`

const Link = styled.a`
  color: #828493;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 5px;

  @media only screen and (max-width: 900px) {
    padding: 4px 0;
    margin-bottom: 2px;
  }
`

const Email = styled(Link)`
  color: #ff425e;
  font-weight: 500;
  margin-bottom: 15px;
`

const SocialLink = styled.a`
  margin-right: 10px;

  &:nth-last-child(1) {
    margin-right: 0;
  }
`

const Footer = () => {
  return (
    <Container>
      <ContentWrapper>
        <BrandCol>
          <Row>
            <Logo src={logo} alt="SwiftSole" />
            <Heading>SwiftSole</Heading>
          </Row>
          <Title></Title>
          <Text>© 2022 SwiftSole Development LLC. All rights reserved.</Text>
        </BrandCol>
        <Col>
          <SectionTitle>Products</SectionTitle>
          <Link href="https://swiftsole.app/#products" target="_blank">SwiftSole V3</Link>
          <Link href="https://swiftsole.app/#products" target="_blank">SwiftSole Desktop</Link>
        </Col>
        <Col>
          <SectionTitle>Information</SectionTitle>
          <Link href="https://swiftsole.app/#faq" target="_blank">FAQ</Link>
          <Link href="https://twitter.com/swiftsoleios" target="_blank">Success</Link>
        </Col>
        <Col>
          <SectionTitle>Help</SectionTitle>
          <Link href="https://dash.swiftsole.app/tos" target="_blank">Terms of Service</Link>
          <Link href="https://dash.swiftsole.app/privacy-policy" target="_blank">Privacy Policy</Link>
          <Link href="https://dash.swiftsole.app/cookie-policy" target="_blank">Cookie Policy</Link>
          <Link href="https://forms.gle/5dswLzQjHF8e16fN6" target="_blank">Bulk Discounts</Link>
        </Col>
        <ContactCol>
          <SectionTitle>Contact Us</SectionTitle>
          <Email href="mailto:support@swiftsole.app">
            support@swiftsole.app
          </Email>
          <Row>
            <SocialLink href="https://twitter.com/swiftsoleios" target="_blank">
              <img src={twitterIcon} alt="Twitter" />
            </SocialLink>
            <SocialLink href="https://www.instagram.com/swiftsole/" target="_blank">
              <img src={instagramIcon} alt="Instagram" />
            </SocialLink>
            <SocialLink href="https://www.youtube.com/channel/UCSp8P9WQPD2NOo-tTMd5Few" target="_blank">
              <img src={youtubeIcon} alt="YouTube" />
            </SocialLink>
          </Row>
        </ContactCol>
      </ContentWrapper>
    </Container>
  )
}

export default Footer
